<template>
    <div id="pencil-drop-list">
        <!--        <div>我是标题按钮</div>-->
        <drop-list :i-class="iClass" :title="title" :menu-list="headList" :type="type"></drop-list>
    </div>
</template>

<script>
    import DropList from "./DropList";

    export default {
        name: "PencilDropList",
        components: {
            DropList
        },
        data(){
            return{
                iClass:"w-e-icon-pencil2",
                title:"文字颜色",
                type:'inlineBlock',

                // headList:[{ elem:{ elem: '<i style="color:\' + \'#000000\' + \';" class="w-e-icon-pencil2"></i>', value: '#000000' },{ elem:{ elem: '<i style=\"color:#eeece0;\" class=\"w-e-icon-pencil2\"></i>', value: '#eeece0' }]
                headList:[{elem:'<i style="color:' + '#000000' + ';" class="w-e-icon-pencil2"></i>',value: '#000000'},{elem:'<i style="color:' + '#eeece0' + ';" class="w-e-icon-pencil2"></i>',value: '#eeece0'},{elem:'<i style="color:' + '#1c487f' + ';" class="w-e-icon-pencil2"></i>',value: '#1c487f'},{elem:'<i style="color:' + '#4d80bf' + ';" class="w-e-icon-pencil2"></i>',value: '#4d80bf'},{elem:'<i style="color:' + '#c24f4a' + ';" class="w-e-icon-pencil2"></i>',value: '#c24f4a'},{elem:'<i style="color:' + '#8baa4a' + ';" class="w-e-icon-pencil2"></i>',value: '#8baa4a'},{elem:'<i style="color:' + '#7b5ba1' + ';" class="w-e-icon-pencil2"></i>',value: '#7b5ba1'},{elem:'<i style="color:' + '#46acc8' + ';" class="w-e-icon-pencil2"></i>',value: '#46acc8'},{elem:'<i style="color:' + '#f9963b' + ';" class="w-e-icon-pencil2"></i>',value: '#f9963b'},{elem:'<i style="color:' + '#ffffff' + ';" class="w-e-icon-pencil2"></i>',value: '#ffffff'},]
            }
        },
    }
</script>

<style scoped>

</style>